import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GGGameConfig} from "../GGGameConfig";
import {GGReelSymbolName} from "../symbols/GGReelSymbolName";
import {GGParsedGameData} from "../server/data/GGParsedGameData";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GGGameModuleConfig} from "../GGGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite, TweenLite} from "gsap";
import {GGHelper} from "../utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GGReelSymbol} from "../symbols/GGReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GGSoundConfig} from "../GGSoundConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class SymbolLanding extends ReelStopPresentationController {

    private _fsLeft:number;
    private _updatedPlusOneThisSpin:boolean = false;

    constructor(index:number) {
        super(index, "SymbolLanding");
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
    }

    private onBeforeSpinStart():void {
        GGGameModuleConfig.soundPlayer.prepareLandingSounds();

    }

    protected parseFeatureGameData(data:GGParsedGameData):void {
        this._updatedPlusOneThisSpin = false;
        this._fsLeft = data.freespinsLeft;
    }

    public onReelStopSymbolAttention(data:IReelStoppedData):void {
        const symbol:StateReelSymbol = data.symbols![0];
        if(symbol.symName === GGReelSymbolName.DEADWILD) {
            return;
        }

        symbol.changeState({
            state : GGGameConfig.instance.SYMBOL_STATES.landing
        });

    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if((<GGParsedGameData>this._gameData!).isFreespinMode && !GGGameConfig.instance.FAULTY_WIN_CAP) {
            let hasPlusOneAnimation:number = 0;
            const plusOneTl:TimelineLite = new TimelineLite({paused : true});
            const gameData:GGParsedGameData = (<GGParsedGameData>this._gameData!);
            const reels:string[] = gameData.isAvalancheMode ? gameData.newSymbols[data.reelId] : gameData.reels[data.reelId];
            const startId:number = gameData.isAvalancheMode ? (8 - gameData.gameAreaSize) : 0;
            reels.forEach((symName:string, i:number) => {
                if(symName === ReelSymbolName.SCATTER) {
                    const symbol:GGReelSymbol = <GGReelSymbol>Reels.getSymbol(data.reelId, i + startId);
                    hasPlusOneAnimation++;
                    const plusOne:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("plusOne")[0]);
                    const animationScale:number = MathHelper.roundToDecimals((<GGReelSymbol>symbol).symHeight / 181, 2);
                    plusOne.alpha = 0;
                    plusOne.visible = false;
                    plusOne.anchor.set(0.5, 0.5);
                    plusOne.scale.set(animationScale, animationScale);
                    StageManager.getLayer(GGGameConfig.instance.LAYERS.GOBLINS.name).addChild(plusOne);
                    plusOne.position = GGHelper.copyLocalPosition(plusOne, symbol);
                    const toPos:number = plusOne.position.y - 100;
                    plusOneTl.add([
                        () => {
                            plusOne.visible = true;
                            GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.FS_PLUS);
                        },
                        TweenLite.to(plusOne, 2, {y : toPos}),
                        TweenLite.fromTo(plusOne, 2, {alpha : 1}, {alpha : 0})
                    ], 0);
                    plusOneTl.add(() => plusOne.destroy());
                }
            });
            if(hasPlusOneAnimation > 0) {
                if(!this._updatedPlusOneThisSpin) {
                    plusOneTl.add(GGGameModuleConfig.fsCounter.updateToSpinsLeft(this._fsLeft, "", false), 1);
                    this._updatedPlusOneThisSpin = true;
                }

                plusOneTl.add(() => this.dispatchCompleteEvent(data.reelId));
                plusOneTl.play(0);

                return;
            }
        }

        this.dispatchCompleteEvent(data.reelId);
    }
}